type FunctionType<P extends unknown[] = unknown[], T = unknown> = (
  ...args: P
) => T;

type RetryConfig = {
  // Number of retries, and interval in ms to wait before retrying
  tries?: number[];
};

/**
 * Returns a function that will retry the underlying function a number of times if it fails.
 */
export function retry<P extends unknown[], T>(
  fn: FunctionType<P, Promise<T>>,
  { tries = [1000, 2000, 4000] }: RetryConfig = {}
): FunctionType<P, Promise<T>> {
  if (tries.length === 0) {
    return fn;
  }

  return (...args: P): Promise<T> => {
    return fn(...args).catch(
      () =>
        new Promise((res) =>
          setTimeout(() => {
            res(retry(fn, { tries: tries.slice(1) })(...args));
          }, tries[0])
        )
    );
  };
}
